function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3086 67.6914C15.218 64.6008 17.2672 58.1172 15.6883 54.3211C14.1094 50.525 8.0625 47.1992 8.0625 43C8.0625 38.8008 14.0422 35.6094 15.6883 31.6789C17.3344 27.7484 15.218 21.3992 18.3086 18.3086C21.3992 15.218 27.8828 17.2672 31.6789 15.6883C35.475 14.1094 38.8008 8.0625 43 8.0625C47.1992 8.0625 50.3906 14.0422 54.3211 15.6883C58.2516 17.3344 64.6008 15.218 67.6914 18.3086C70.782 21.3992 68.7328 27.8828 70.3117 31.6789C71.8906 35.475 77.9375 38.8008 77.9375 43C77.9375 47.1992 71.9578 50.3906 70.3117 54.3211C68.6656 58.2516 70.782 64.6008 67.6914 67.6914C64.6008 70.782 58.1172 68.7328 54.3211 70.3117C50.525 71.8906 47.1992 77.9375 43 77.9375C38.8008 77.9375 35.6094 71.9578 31.6789 70.3117C27.7484 68.6656 21.3992 70.782 18.3086 67.6914Z",
  stroke: "#feca39",
  strokeWidth: 9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.7812 34.9375L38.0617 53.75L28.2188 44.3438",
  stroke: "#feca39",
  strokeWidth: 9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgVerifiedCheckmark = function SvgVerifiedCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVerifiedCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/verified-checkmark.e302d108.svg";
export { ForwardRef as ReactComponent };